<template>
  <div class="covs-detail">
    <div class="container">
      <h1>{{ serviceDetail.title }}</h1>
      <div class="service-meta">
        <span class="service-category">{{ serviceDetail.category }}</span>
      </div>
      <div class="service-content">

        <div class="service-description">
          <h2>{{ serviceDetail.descriptionTitle || '介绍' }}</h2>
          <p>{{ serviceDetail.description }}</p>
          <div class="service-image">
            <img :src="serviceDetail.heroImage" :alt="serviceDetail.title" class="service-main-image" />
          </div>
        </div>
        <div class="service-features" v-if="serviceDetail.features && serviceDetail.features.length > 0">
          <h2>{{ serviceDetail.featuresTitle || '核心功能' }}</h2>
          <ul>
            <li v-for="(feature, index) in serviceDetail.features" :key="index">{{ feature }}</li>
          </ul>
          <div class="service-image" v-if="serviceDetail.featuresImage">
            <img :src="serviceDetail.featuresImage" :alt="serviceDetail.featuresTitle" class="service-main-image" />
          </div>
        </div>
        
        <div class="service-table" v-if="$route.params.id === 'online-2'">
          <h2>{{ serviceDetail.tableTitle || '表格标题' }}</h2>
          <table class="comparison-table">
            <thead>
              <tr>
                <th>监测因子</th>
                <th>监测方法</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in serviceDetail.tableData" :key="index">
                <td>{{ item.factor }}</td>
                <td>{{ item.method }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div class="service-table" v-if="$route.params.id === 'online-1'">
          <h2>VOCs监测技术对比</h2>
          <table class="comparison-table">
            <thead>
              <tr>
                <th>监测技术</th>
                <th>监测对象</th>
                <th>优点</th>
                <th>不足之处</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>光离子化检测 (PID)</td>
                <td>THC、TVOC</td>
                <td>检测器体积小巧、无需辅助气体，常用于现场便携仪器使用；主要用于室内环境监测、应急监测、危险/泄漏气体预警、污染源追踪中TVOC含量的监测分析。</td>
                <td>PID能检测响应的VOCs种类和所使用的紫外灯能量有关，对不同化合物的响应系数也不同，对一些短链烷烃响应极低甚至无法检测到。</td>
              </tr>
              <tr>
                <td>催化氧化-非分散红外吸收 (NDIR)</td>
                <td>THC</td>
                <td></td>
                <td>技术稳定性和灵敏度不高，易受共存干扰物的影响，且在催化氧化过程中往往存在催化剂中毒、转化不完全、转化效率低等问题，因此目前在实际应用中并不多见。</td>
              </tr>
              <tr>
                <td>气象色谱-氢火焰离子化 (GC-FID)</td>
                <td>THC、TVOC、NMTHC、VOCs组分</td>
                <td>检测灵敏度高，选择性强，可监测TVOC和VOCs单个组分，可同时分析多个组分；这一在线监测技术在欧美日韩等已有广泛应用并在我国部分经济发达城市得到引进，取得了良好的效果。</td>
                <td>不足之处是如果测量多个组分，检测周期相对较长，对检测器性能要求高。</td>
              </tr>
              <tr>
                <td>傅立叶变换红外光谱 (FTIR)</td>
                <td>VOCs组分</td>
                <td>检测VOCs种类较多，可同时分析多个组分，现场测量检测周期短，响应时间快；</td>
                <td>但其检测分析的灵敏度一般较色谱技术低，且光学器件维护成本高、维护量较大。</td>
              </tr>
              <tr>
                <td>差分吸收光谱 (DOAS)</td>
                <td>VOCs组分 (苯系物)</td>
                <td>可同时分析多个组分；一般现场采取非接触式直接连续测量，无需预处理，保证气体不失真，响应时间很快，可实现测量光路区域内的线监测；</td>
                <td>但其检测分析的灵敏度一般较色谱技术低，检测VOCs种类有限，目前主要是苯、甲苯等苯系物。</td>
              </tr>
              <tr>
                <td>离子迁移谱 (IMS)</td>
                <td>VOCs组分</td>
                <td>检测灵敏度高，相比于质谱技术不需要真空系统，仪器结构简单，成本较低，可测量浓度低、腐蚀性高的气体；</td>
                <td>但该技术特性差，可测量VOCs种类有限，干扰化合物较多。目前，IMS作为便携式监测仪在应急监测、食品安全监测等领域有所应用。</td>
              </tr>
              <tr>
                <td>调谐激光吸收光谱 (TDLAS)</td>
                <td>CH4等</td>
                <td>检测灵敏度高，选择性强，干扰很小；现场采取非接触式直接连续测量，无需预处理，保证气体不失真，响应时间很快，实时性强，可实现测量光路区域内的线监测</td>
                <td>该技术单一光源一般只能完成单一组分测量。</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
      <div class="back-link">
        <router-link to="/covs">← 返回VOCs综合管控</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppCovsDetail',
  data() {
    return {
      serviceDetail: {
        title: '',
        category: '',
        description: '',
        heroImage: '',
        features: [],
        benefits: [],
        gallery: []
      }
    }
  },
  mounted() {
    this.loadServiceDetail(this.$route.params.id);
  },
  methods: {
    loadServiceDetail(id) {
      const serviceData = {
        'online-1': {
          title: '固定源挥发性有机物（VOCs）在线监测系统',
          category: 'VOCs在线监测',
          description: '根据《重点区域大气污染防治"十二五"规划》有机废气净化率达到90%以上。各级政府及主管部门正在积极推进有机化工等行业挥发性有机物控制，净化效率应不低于90%。表面涂装工艺挥发性有机物排放控制，使用溶剂型涂料的表面涂装工序必须密闭作业，配备有机废气收集系统，安装高效回收净化设施，有机废气净化率达到90%以上。同时也要进行溶剂使用工艺挥发性有机物治理，烘干车间需安装活性碳等吸附设备回收有机溶剂，对车间有机废气进行净化处理，净化效率达到90%以上。因此，为保证能满足VOCs污染物治理设备过程控制的要求，必须实现连续监测。各级，各地政府也为此制定了相关技术规范，标准及要求。',
          heroImage: require('../assets/9.jpg'),
          featuresTitle: '《上海市固定污染源非甲烷总烃在线监测系统安装及联网技术要求（试行）》',
          features: [
            '《上海市固定污染源非甲烷总烃在线监测系统安装及联网技术要求（试行）》',
            '3.3 非甲烷总烃在线监测对固定污染源排放的非甲烷总烃进行连续地、实时地跟踪测定；每个固定污染源的总测定小时数不得小于排放设施总运行小时数的75%。',
            '3.5 有效小时均值连续排放或间歇排放超过1h的，在1h内不少于75%有效数据的平均值；间歇排放小于1h，在间歇排放时间内不少于75%有效数据的平均值。',
            'HJ/T75 固定污染源烟气排放连续监测系统技术规范',
            '3.1 烟气排放连续监测对固定污染源排放的污染物进行连续地、实时地跟踪测定；每个固定污染源的测定时间不得小于锅、炉窑总运行时间的75%；在每小时的测定时间不得低于45min。',
            '3.4 有效小时均值整点1h内不少于45 min的有效数据的算术平均值。',
            'HJ/T76 固定污染源排放烟气连续监测系统技术要求及检测方法',
            '3.4 烟气排放连续监测对固定污染源排放的污染物进行连续地、实时地跟踪测定；每个固定污染源的测定时间不得小于锅、炉窑总运行时间的75%；在每小时的测定时间不得低于45min。',
            'GB16297-1996 大气污染物综合排放标准',
            '8.2.1排气筒中废气的采样以连续1 小时的采样获取平均值;或在1 小时内以等时间间隔采集4 个样品并计平均值',
            '8.2.3 特殊情况下的采样时间和频次若某排气筒的排放为间断性排放排放时间小于1 小时，应在排放时段内实行连续采样或在排放时段内以等时间间隔采集2 个4 个样品并计平均值；若某排气筒的排放为间断性排放排放时间大于1 小时，则应在排放时段内按8.2.1的要求采样。'
          ],
          benefits: [
            '24小时不间断监测，确保数据完整性',
            '高精度传感器，检测限低至ppb级别',
            '自动化程度高，减少人工干预',
            '符合国家环保标准，数据具有法律效力',
            '系统稳定可靠，适应恶劣工业环境',
            '支持第三方平台对接，数据共享便捷'
          ],
          gallery: [
            'https://picsum.photos/600/400?random=101',
            'https://picsum.photos/600/400?random=102',
            'https://picsum.photos/600/400?random=103'
          ]
        },
        'online-2': {
          title: 'VOCs排放在线监测系统（固定源、厂界/园区 VOCs 在线监测系统）',
          category: 'VOCs在线监测',
          descriptionTitle: 'VOCs在线监测仪',
          description: '隆之智VOCs在线监测仪（GC-FID/GC-PID）通过采集废气管道排放的VOCs气体，通过测量性能优越的进口GC-FID或GC-PID仪表探头检测苯、甲苯、二甲苯等多达数百种VOCs气体的总浓度。\n\n监测流程：被测气体被采样系统抽取后， 经除尘、除水等处理后通过管线引入在线气相色谱仪。色谱柱将由载气带入的样气进行组分分离，分离后的各组分气体依次进入检测器进行检测，而后在线色谱工作站系统自动完成数据采集、分析、处理、储存和导出。',
          heroImage: require('../assets/9.jpg'),
          featuresTitle: '厂界/园区 VOCs 在线监测系统',
          features: [
            '隆之智环保可在重点污染企业/园区四周或主导上、下风向的厂界/园区边界处设置监测站，根据企业不同的特征污染物选用先进且技术成熟的监测方法为企业提供测量准确，性能稳定的监测仪器。'
          ],
          featuresImage: require('../assets/10.jpg'),
          tableTitle: '常见监测因子与监测方法',
          tableData: [
            { factor: '非甲烷总烃', method: 'GC-FID' },
            { factor: '苯、甲苯、二甲苯', method: 'GC-FID 或GC-PID' },
            { factor: '氯化氢', method: '激光吸收光谱法' },
            { factor: '硫化氢', method: '紫外荧光法' },
            { factor: '氨气', method: '化学发光法' },
            { factor: 'PM2.5颗粒物', method: 'β射线吸收法或微量震荡天平法' }
          ]
        },
        'online-3': {
          title: '数据采集终端',
          category: 'VOCs在线监测',
          description: '数据采集终端是VOCs在线监测系统的核心设备，负责采集各类传感器的数据，并进行初步处理和存储。终端支持多种传感器接入，包括VOCs传感器、温湿度传感器、压力传感器等，能够构建完整的监测网络。',
          heroImage: 'https://picsum.photos/800/400?random=13',
          features: [
            '多通道数据采集，支持多种传感器',
            '高精度ADC转换，数据准确可靠',
            '大容量存储，支持本地数据缓存',
            '多种通信接口，支持RS485、以太网、4G等',
            '低功耗设计，支持太阳能供电',
            '远程配置和升级，维护方便'
          ],
          benefits: [
            '集成度高，减少设备数量',
            '兼容性强，支持主流传感器品牌',
            '数据安全性高，支持加密传输',
            '扩展性好，可根据需求增加传感器',
            '稳定可靠，适应恶劣环境',
            '成本效益高，降低整体投入'
          ],
          gallery: [
            'https://picsum.photos/600/400?random=106',
            'https://picsum.photos/600/400?random=107'
          ]
        },
        'gov-1': {
          title: '政府/园区级VOCs综合管控服务',
          category: '政府/园区级VOCs综合管控',
          description: '根据《石化行业挥发性有机物综合整治方案》文件要求，到2017年，全国石化行业基本完成VOCs综合整治工作，建成VOCs监测监控体系，现状情况距离整治方案中的工作目标仍具有一定的差距，形势严峻。\n\n\n\n因此，隆之智环保参照美国标准，应用国家规范性的核算统计方法，自主研发VOCs综合管控平台，实现了"政府引导和服务、企业施治和申报、社会参与和监督"多方参与的环境监管新模式。\n\n\n环保部门通过制定具有驱动性的管控要求，引导企业自主申报污染物真实排放情况;鼓励社会参与和监督，充分发挥群众监督和社会舆论的积极作用;环保部门进行动态监管，逐步将工作职能重点放在引导和监管上，以适应新形式下的环境保护要求。\n\n建立和完善关键环境数据（检测、监测、治理等）的存储、计算和统计分析平台；\n实施全过程精细化管理；\n\n提高环保工作的技术支撑；\n实现VOCs综合管控效果。',
          heroImage: require('../assets/13.png'),
          featuresTitle: '业务方向',
          features: [
            '一企一策（一厂一策）报告编制',
            '十二源项排查（污染源排查）报告编制',
            'VOCs管控管家服务'
          ],
          benefits: [
            '统一管理，提高监管效率',
            '数据共享，促进信息互通',
            '科学决策，基于数据分析制定政策',
            '预防为主，提前发现环境风险',
            '降低成本，减少重复建设',
            '提升形象，展示园区环保成果'
          ],
          gallery: [
            'https://picsum.photos/600/400?random=108',
            'https://picsum.photos/600/400?random=109',
            'https://picsum.photos/600/400?random=110'
          ]
        },
        'gov-2': {
          title: '应急指挥系统',
          category: '政府/园区级VOCs综合管控',
          description: '应急指挥系统是针对突发环境事件设计的快速响应平台，整合了监测数据、应急资源、专家库等信息，为应急决策提供全面支持。系统能够快速定位污染源，评估影响范围，制定处置方案，协调各部门联动，最大程度减少环境损害。',
          heroImage: 'https://picsum.photos/800/400?random=22',
          features: [
            '实时监测数据接入，掌握现场情况',
            '污染扩散模拟，预测影响范围',
            '应急资源调度，快速调配人员和设备',
            '专家远程支持，提供专业指导',
            '多部门协同，统一指挥调度',
            '事后评估总结，完善应急预案'
          ],
          benefits: [
            '快速响应，缩短应急响应时间',
            '科学决策，提高处置效率',
            '资源优化，合理调配应急力量',
            '信息透明，及时发布预警信息',
            '减少损失，降低环境影响',
            '经验积累，持续改进应急能力'
          ],
          gallery: [
            'https://picsum.photos/600/400?random=111',
            'https://picsum.photos/600/400?random=112'
          ]
        },
        'gov-3': {
          title: '监管执法平台',
          category: '政府/园区级VOCs综合管控',
          description: '监管执法平台是环保监管部门专用的信息化平台，支持企业监管、执法记录、数据分析等功能。平台整合了企业的VOCs排放数据、监测报告、执法记录等信息，为监管部门提供全面的监管工具，提高执法效率和透明度。',
          heroImage: 'https://picsum.photos/800/400?random=23',
          features: [
            '企业档案管理，建立完整的企业信息库',
            '排放数据监控，实时掌握企业排放状况',
            '执法记录管理，规范执法流程',
            '违法案件处理，支持案件立案和处罚',
            '数据统计分析，生成监管报告',
            '移动执法支持，现场执法便捷高效'
          ],
          benefits: [
            '提高效率，减少人工工作量',
            '规范流程，统一执法标准',
            '数据准确，避免人为错误',
            '透明公正，执法过程可追溯',
            '科学监管，基于数据制定政策',
            '降低成本，减少现场检查频次'
          ],
          gallery: [
            'https://picsum.photos/600/400?random=113',
            'https://picsum.photos/600/400?random=114'
          ]
        },
        'enterprise-1': {
          title: '集团/企业级VOCs综合管控',
          category: '集团/企业级VOCs综合管控服务',
          description: '进行VOCs管控，首先就要找到排放的源头，并监测估算出排放量。企业的排放源主要是生产工艺系统、储运系统和废水处理系统，其然而，对企业来说，这项工作尤其浩大，必须通过技术手段进行管理。隆之智环保VOCs综合管控平台技术，正是针对这一难题而研发的。\n\n隆之智根据国家对企业VOCs排放的管控政策要求，建立了企业VOCs排放源的分类排查清单，开发出了相应行业的的模型软件，整合了VOCs排放量的分类核算方法及泄漏检测与修复程序，通过VOCs综合管控平台服务各行业企业。\n\n\n\nVOCs综合管控技术可指导企业对包括生产工艺系统、废水集输处理系统和储运系统的全过程VOCs排放，进行源清单建立、摸底核算、对生产工艺系统VOCs实施泄漏检测与修复，以及及时掌握在线监测设备及治理设备的运行管理情况，从而有效控制VOCs的泄漏与排放，基本能够实现企业自己的排查核算分析。\n\n同时，应用"互联网+"技术，通过网络平台远程控制、大数据分析处理，对VOCs管控情况实现了精细化管理，平台推广使用后，企业环保、减排效果十分明显，同时降低物耗也可以为企业带来一定成本节约。',
          heroImage: require('../assets/14.png')
        },
        'enterprise-2': {
          title: 'LDAR管理系统',
          category: '集团/企业级VOCs综合管控服务',
          description: 'LDAR管理系统是泄漏检测与修复的全流程管理平台，从检测计划制定、现场检测、数据录入到修复跟踪，实现全流程数字化管理。系统支持移动端操作，检测人员可现场录入数据，提高检测效率，降低泄漏风险。',
          heroImage: 'https://picsum.photos/800/400?random=32',
          features: [
            '检测计划管理，自动生成检测任务',
            '现场数据录入，支持移动端操作',
            '泄漏评估，自动计算泄漏率',
            '修复跟踪，记录修复过程和效果',
            '数据分析，识别泄漏热点',
            '报表生成，满足监管要求'
          ],
          benefits: [
            '提高效率，减少人工工作量',
            '降低成本，减少VOCs排放',
            '规范流程，统一检测标准',
            '数据准确，避免人为错误',
            '及时修复，降低环境影响',
            '持续改进，优化检测策略'
          ],
          gallery: [
            'https://picsum.photos/600/400?random=117',
            'https://picsum.photos/600/400?random=118'
          ]
        },
        'enterprise-3': {
          title: '合规报表系统',
          category: '集团/企业级VOCs综合管控服务',
          description: '合规报表系统是专门为企业环保合规设计的报表生成平台，根据国家和地方的环保法规要求，自动生成各类合规报表，包括排放年报、月报、季报等。系统支持数据自动采集、报表自动生成、在线提交等功能，大大减轻企业的报表负担。',
          heroImage: 'https://picsum.photos/800/400?random=33',
          features: [
            '自动采集监测数据，减少人工录入',
            '多种报表模板，满足不同监管要求',
            '报表自动生成，一键导出',
            '在线提交，直接对接监管平台',
            '报表历史管理，便于查询和审计',
            '数据校验，确保报表准确性'
          ],
          benefits: [
            '节省时间，减少人工工作量',
            '降低错误，避免数据录入错误',
            '及时提交，避免逾期处罚',
            '合规经营，满足监管要求',
            '降低成本，减少人工投入',
            '提升效率，提高管理水平'
          ],
          gallery: [
            'https://picsum.photos/600/400?random=119',
            'https://picsum.photos/600/400?random=120'
          ]
        }
      };
      
      this.serviceDetail = serviceData[id] || {
        title: '服务不存在',
        category: '',
        description: '抱歉，您访问的服务不存在或已被删除。',
        heroImage: '',
        features: [],
        benefits: [],
        gallery: []
      };
    }
  }
}
</script>

<style scoped>
.covs-detail {
  padding: 80px 0;
  background: linear-gradient(135deg, #f9f9f9 0%, #e6f3ee 100%);
}

.container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
}

h1 {
  font-size: 36px;
  margin-bottom: 20px;
  color: #333;
  text-align: center;
}

.service-meta {
  text-align: center;
  margin-bottom: 40px;
}

.service-category {
  display: inline-block;
  background-color: #42b983;
  color: white;
  padding: 8px 20px;
  border-radius: 4px;
  font-size: 16px;
}

.service-content {
  background-color: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 40px;
}



.service-description h2,
.service-features h2 {
  font-size: 28px;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #42b983;
}

.service-description p {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 30px;
}

.service-features ul {
  list-style: none;
  padding: 0;
  margin-bottom: 30px;
}

.service-features li {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 15px;
  padding-left: 0;
  position: relative;
}

.service-features li::before {
  content: '';
  position: absolute;
  left: 0;
  color: #42b983;
  font-weight: bold;
  font-size: 18px;
}

.service-image {
  margin-top: 40px;
  text-align: center;
}

.service-main-image {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.service-table {
  margin-top: 40px;
}

.service-table h2 {
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #42b983;
}

.comparison-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}

.comparison-table th {
  background-color: #42b983;
  color: white;
  padding: 15px;
  text-align: left;
  font-weight: bold;
}

.comparison-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #e0e0e0;
}

.comparison-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.comparison-table tr:hover {
  background-color: #e6f3ee;
}

@media screen and (max-width: 768px) {
  .comparison-table {
    display: block;
    overflow-x: auto;
  }
  
  .service-table h2 {
    font-size: 20px;
  }
}

.back-link {
  text-align: center;
}

.back-link a {
  color: #42b983;
  text-decoration: none;
  font-size: 16px;
  font-weight: bold;
  transition: color 0.3s ease;
}

.back-link a:hover {
  color: #3aa876;
  text-decoration: underline;
}

@media screen and (max-width: 768px) {
  .covs-detail {
    padding: 60px 0;
  }

  h1 {
    font-size: 28px;
  }

  .service-content {
    padding: 30px;
  }



  .service-description h2,
  .service-features h2 {
    font-size: 24px;
  }


}

@media screen and (max-width: 480px) {
  .covs-detail {
    padding: 40px 0;
  }

  h1 {
    font-size: 24px;
  }

  .service-content {
    padding: 20px;
  }



  .service-description h2,
  .service-features h2 {
    font-size: 20px;
  }

  .service-description p,
  .service-features li {
    font-size: 14px;
  }

  .benefit-item {
    padding: 15px;
  }

  .benefit-item p {
    font-size: 13px;
  }


}
</style>